import * as React from 'react';
import classnames from 'classnames';

const ProductDetailDrawerStack = ({ children , className  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('product-detail-drawer-stack', className)
    }, children);
};

export { ProductDetailDrawerStack };
//# sourceMappingURL=ProductDetailDrawerStack.js.map
